export const state = () => {
	return {
		orders: [],
		ttl_orders: null,
		cache_duration_orders: 3600000, // 1 hour
		cache_key_orders: '',
	}
}

function isInCacheOrders(state, companyId, creatorId) {
	if (state.cache_key_orders !== buildCacheKeyOrders(companyId, creatorId)) {
		return false
	}
	if (state.ttl_orders === null || state.ttl_orders < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyOrders(companyId, creatorId) {
	return `company:${companyId}:loyalty-orders:${creatorId}`
}

export const actions = {
	async list_paginate({ state, commit }, { companyId, params }) {
		if (isInCacheOrders(state, companyId, params.creator_id)) {
			return state.orders
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/orders/`, { params })
			.then((res) => {
				commit('setOrders', { data: res, companyId, creatorId: params.creator_id })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async get_page({ commit }, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				return res
			})
	},
}

export const mutations = {
	setOrders(state, { data, companyId, creatorId }) {
		state.orders = data
		state.ttl_orders = Date.now() + state.cache_duration_orders
		state.cache_key_orders = buildCacheKeyOrders(companyId, creatorId)
	},
}
